import React, { useState } from 'react';
import { MortgageDashboard } from './MortgageDashboard';
import { MortgageFileForm } from './MortgageFileForm';

// Entry point for the Mortgage App Workflow. Switches between the file
// dashboard and the intake form. `agent` carries id/name/isAdmin for ownership.
export const MortgageApp = ({ agent, isAdmin = false }) => {
  const [view, setView] = useState('dashboard'); // 'dashboard' | 'form'
  const [activeFileId, setActiveFileId] = useState(null);

  const openFile = (id) => { setActiveFileId(id); setView('form'); };
  const newFile = () => { setActiveFileId(null); setView('form'); };
  const backToDashboard = () => { setActiveFileId(null); setView('dashboard'); };

  return (
    <div data-testid="mortgage-app">
      {view === 'dashboard' ? (
        <MortgageDashboard agent={agent} isAdmin={isAdmin} onOpen={openFile} onNew={newFile} />
      ) : (
        <MortgageFileForm agent={agent} isAdmin={isAdmin} fileId={activeFileId} onBack={backToDashboard} />
      )}
    </div>
  );
};

export default MortgageApp;
